(function () {
  try {
    const root = document.getElementById("sp-promo-root");
    if (!root) return;

    const API_ENDPOINT = root.dataset.apiEndpoint || "/apps/prudent-quote";
    const LIST_ID = root.dataset.klaviyoListId || "";
    const SITE_ID = root.dataset.klaviyoPubKey || "";
    const qs = window.SP_REG_QR_PARAMS instanceof URLSearchParams
      ? window.SP_REG_QR_PARAMS
      : new URLSearchParams(location.search);

    const $ = (sel, ctx = document) => ctx.querySelector(sel);

    // --- Analytics helper ---
    const dataLayer = (window.dataLayer = window.dataLayer || []);
    function track(event, payload = {}) {
      try { dataLayer.push({ event, ...payload }); } catch {}
    }

    function debounce(fn, wait = 200) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn(...args), wait);
      };
    }

    // --- Validation UI Helpers ---
    function clearError(inputEl) {
      if (!inputEl) return;
      inputEl.setAttribute("aria-invalid", "false");
      inputEl.classList.remove("input--error");
      const group = inputEl.closest(".input-group") || inputEl.parentElement;
      if (!group) return;
      const overlay = group.querySelector(".sp-error");
      if (overlay) overlay.remove();
    }

    function showError(inputEl, text) {
      if (!inputEl) return;
      inputEl.setAttribute("aria-invalid", "true");
      inputEl.classList.add("input--error");
      const group = inputEl.closest(".input-group") || inputEl.parentElement;
      if (!group) return;
      let overlay = group.querySelector(".sp-error");
      if (overlay) overlay.remove();
      overlay = document.createElement("div");
      overlay.className = "sp-error";
      overlay.setAttribute("role", "alert");
      overlay.innerHTML = '<img class="sp-error__icon" alt="" src="https://cdn.shopify.com/s/files/1/0339/3110/0219/files/error-icon.svg?v=1761775488" /><span class="sp-error__text"></span>';
      overlay.querySelector(".sp-error__text").textContent = String(text);
      group.appendChild(overlay);
    }

    function clearAllErrors(formEl) {
      formEl.querySelectorAll(".message.message--error").forEach((n) => n.remove());
      formEl.querySelectorAll("[aria-invalid='true']").forEach((el) => {
        el.setAttribute("aria-invalid", "false");
        el.classList.remove("input--error");
      });
    }

    function isValidEmail(s) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(s || "").trim());
    }

    function isoDate(d) {
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${y}-${m}-${day}`;
    }

    // --- Breed Helpers ---
    function formatBreedLabel(breedString) {
      if (!breedString || typeof breedString !== "string") return "";
      const parts = breedString.split("~");
      return parts.length === 3 ? parts[2].trim() : breedString.trim();
    }

    function findCanonicalFromLabel(label, items) {
      const needle = (label || "").trim().toLowerCase();
      if (!needle) return "";
      const exact = items.find((full) => formatBreedLabel(full).toLowerCase() === needle);
      if (exact) return exact;
      const loose = items.find((full) => formatBreedLabel(full).toLowerCase().includes(needle));
      return loose || "";
    }

    function prioritizeMixedBreeds(items) {
      if (!Array.isArray(items) || !items.length) return items || [];
      const wantedOrder = [
        { size: "small", match: /small/i },
        { size: "medium", match: /medium/i },
        { size: "large", match: /large/i }
      ];
      const isMixed = (label) => /mixed\s*breed/i.test(label);
      const picked = [];
      const rest = [];
      items.forEach((full) => {
        const label = formatBreedLabel(full);
        if (isMixed(label)) {
          const lower = label.toLowerCase();
          const slot = wantedOrder.findIndex(w => w.match.test(lower));
          if (slot >= 0 && !picked[slot]) picked[slot] = full;
          else rest.push(full);
        } else {
          rest.push(full);
        }
      });
      return [...wantedOrder.map((_, i) => picked[i]).filter(Boolean), ...rest];
    }

    function prioritizeDomesticCatBreeds(items) {
      if (!Array.isArray(items) || !items.length) return items || [];
      const targets = ['domestic shorthair','domestic mediumhair','domestic longhair'];
      const picked = [];
      const rest = [];
      items.forEach((full)=>{
        const label = formatBreedLabel(full).toLowerCase();
        const idx = targets.indexOf(label);
        if (idx !== -1 && !picked[idx]) picked[idx] = full;
        else rest.push(full);
      });
      const compact = targets.map((_,i)=>picked[i]).filter(Boolean);
      const setPicked = new Set(compact.map(String));
      return [...compact, ...rest.filter(x => !setPicked.has(String(x)))];
    }

    // --- DOM Elements ---
    const form = $("#sp-promo-form", root);
    const results = $("#sp-promo-results", root);
    const progressBar = $("#sp-promo-progress-bar", root);
    const formSubtitle = $("#sp-promo-subtitle", root);

    // Step 1
    const step1 = $("#sp-promo-step-1", root);
    const firstName = $("#sp-promo-first-name", root);
    const lastName = $("#sp-promo-last-name", root);
    const emailInput = $("#sp-promo-email", root);
    const zipInput = $("#sp-promo-zip", root);
    const nextBtn = $("#sp-promo-next-btn", root);

    // Step 2 & Branching
    const step2 = $("#sp-promo-step-2", root);
    const branchYes = $("#sp-promo-branch-yes", root);
    const branchNo = $("#sp-promo-branch-no", root);
    const petFields = $("#sp-promo-pet-fields", root);
    const consent = $("#sp-promo-consent", root);
    const backBtn = $("#sp-promo-back-btn", root);
    const submitBtn = $("#sp-promo-submit-btn", root);
    let petIntent = null; // Tracks if they want to add a pet

    // Pet Fields
    const speciesSelect = $("#sp-promo-species", root);
    const genderSelect = $("#sp-promo-gender", root);
    const petName = $("#sp-promo-pet-name", root);
    const dobInput = $("#sp-promo-dob", root);
    const breedInput = $("#sp-promo-breed", root);
    const breedHidden = $("#sp-promo-breed-hidden", root);

    // --- Toggle Groups Init ---
    function initToggleGroups() {
      const groups = root.querySelectorAll(".sp-toggle-group");
      groups.forEach((group) => {
        const targetSel = group.getAttribute("data-target");
        const hidden = root.querySelector(targetSel);
        if (!hidden) return;

        function syncActive() {
          const val = hidden.value || "";
          group.querySelectorAll(".sp-toggle").forEach((btn) => {
            const active = btn.getAttribute("data-value") === val;
            btn.classList.toggle("is-active", active);
            btn.setAttribute("aria-pressed", active ? "true" : "false");
          });
        }

        group.addEventListener("click", (e) => {
          const btn = e.target.closest(".sp-toggle");
          if (!btn) return;
          e.preventDefault();
          const val = btn.getAttribute("data-value");
          if (hidden.value !== val) {
            hidden.value = val;
            hidden.dispatchEvent(new Event("change", { bubbles: true }));
            syncActive();
          }
        });
        syncActive();
      });
    }
    initToggleGroups();

    // --- Step 1 Validation ---
    function validateStep1() {
      clearAllErrors(form);
      let firstInvalid = null;

      if (!firstName.value.trim()) { showError(firstName, "First name required"); firstInvalid = firstInvalid || firstName; }
      if (!lastName.value.trim()) { showError(lastName, "Last name required"); firstInvalid = firstInvalid || lastName; }
      
      const emailVal = emailInput.value.trim();
      if (!isValidEmail(emailVal)) { showError(emailInput, "Valid email required"); firstInvalid = firstInvalid || emailInput; }
      
      const z = (zipInput.value || "").replace(/\D/g, "");
      if (z.length !== 5) { showError(zipInput, "5-digit ZIP required"); firstInvalid = firstInvalid || zipInput; }

      if (firstInvalid) {
        firstInvalid.scrollIntoView({ behavior: "smooth", block: "center" });
        try { firstInvalid.focus({ preventScroll: true }); } catch {}
      }
      return !firstInvalid;
    }

    // --- Step 2 Validation ---
    function validateStep2() {
      clearAllErrors(step2);
      let firstInvalid = null;

      // Only validate pet fields if they explicitly chose 'Yes'
      if (petIntent === true) {
        if (!speciesSelect.value) { showError(speciesSelect, "Select a species"); firstInvalid = firstInvalid || speciesSelect; }
        if (!genderSelect.value) { showError(genderSelect, "Select a gender"); firstInvalid = firstInvalid || genderSelect; }
        if (!petName.value.trim()) { showError(petName, "Pet name required"); firstInvalid = firstInvalid || petName; }
        
        if (!dobInput.value) { 
          showError(dobInput, "Date of birth required"); firstInvalid = firstInvalid || dobInput; 
        } else {
          const d = new Date(dobInput.value + "T00:00:00");
          const min = new Date(dobInput.getAttribute("min"));
          const max = new Date(dobInput.getAttribute("max"));
          if (isNaN(d.getTime()) || d < min || d > max) {
            showError(dobInput, "Valid date of birth required"); firstInvalid = firstInvalid || dobInput;
          }
        }
        syncHiddenBreed();
        if (!breedHidden.value) { showError(breedInput, "Choose a breed from the list"); firstInvalid = firstInvalid || breedInput; }
      }

      if (firstInvalid) {
        firstInvalid.scrollIntoView({ behavior: "smooth", block: "center" });
        try { firstInvalid.focus({ preventScroll: true }); } catch {}
      }
      return !firstInvalid;
    }

    const titleEl = $("#sp-promo-title", root);
    const subtitleEl = $("#sp-promo-subtitle", root);

    // --- Step 1 to Step 2 Progression ---
    nextBtn.addEventListener("click", () => {
      if (!validateStep1()) return;
      step1.style.display = "none";
      step2.style.display = "block";
      progressBar.style.width = "65%";
      
      // Update Text for Step 2
      titleEl.textContent = "Tell Us About Your Pet";
      subtitleEl.textContent = "Add a few details so we can send more helpful tips, reminders, and perks made just for them.";
    });

    backBtn.addEventListener("click", () => {
      step2.style.display = "none";
      step1.style.display = "block";
      progressBar.style.width = "15%"; 
      
      // Revert Text for Step 1
      titleEl.textContent = "Get 10% Off Your First Order";
      subtitleEl.textContent = "Sign up for helpful pet care tips, exclusive offers, and everything you need to help your pup feel calm and comforted.";
    });

    // --- Step 2 Branching Logic (Accordion) ---
    const branchOptionsContainer = $("#sp-promo-branch-options", root);

    branchYes.addEventListener("click", () => {
      petIntent = true;
      // Hide the Yes/No buttons and reveal the pet fields
      branchOptionsContainer.style.display = "none";
      petFields.style.display = "block"; 
      submitBtn.disabled = false; 
    });

    branchNo.addEventListener("click", () => {
      petIntent = false;
      branchNo.classList.add("is-active");
      branchYes.classList.remove("is-active");
      petFields.style.display = "none"; 
      submitBtn.disabled = false; 
      clearAllErrors(petFields); 
    });

    submitBtn.addEventListener("click", (e) => {
      e.preventDefault();
      // Failsafe in case the button somehow bypassed disabled state
      if (petIntent === null) return; 
      if (!validateStep2()) return;
      submitPromoForm();
    });

    // --- Input Listeners & Safari Hacks ---
    [firstName, lastName, petName, emailInput].forEach(el => {
      if(el) {
        el.addEventListener("input", () => clearError(el));
      }
    });

    if (zipInput) {
      zipInput.addEventListener("input", () => {
        const digits = (zipInput.value || "").replace(/\D/g, "").slice(0, 5);
        if (zipInput.value !== digits) zipInput.value = digits;
        clearError(zipInput);
      });
    }

    if (consent) {
      consent.addEventListener("change", () => clearError(consent));
    }

    if (dobInput) {
      const today = new Date();
      const min = new Date(today);
      min.setFullYear(today.getFullYear() - 25);
      dobInput.setAttribute("max", isoDate(today));
      dobInput.setAttribute("min", isoDate(min));
      
      const isIOS = /iP(hone|od|ad)/.test(navigator.platform) || (navigator.userAgent.includes('Mac') && 'ontouchend' in document);
      if (isIOS) {
        const dobLabel = root.querySelector('label[for="sp-promo-dob"]');
        const syncDobLabel = () => { if (dobLabel) dobLabel.classList.toggle('is-safari-date-empty', !dobInput.value); };
        syncDobLabel();
        ['input','change','blur'].forEach(evt => dobInput.addEventListener(evt, syncDobLabel));
      }
      ['input','blur','change'].forEach(evt => dobInput.addEventListener(evt, () => clearError(dobInput)));
    }

    if (speciesSelect) speciesSelect.addEventListener('change', () => clearError(speciesSelect));
    if (genderSelect) genderSelect.addEventListener('change', () => clearError(genderSelect));

    // --- Breed Autocomplete Logic ---
    const cache = { breeds: {} };
    breedInput.setAttribute("role", "combobox");
    breedInput.setAttribute("aria-autocomplete", "list");
    breedInput.setAttribute("aria-controls", "sp-promo-breed-dropdown");
    breedInput.removeAttribute("list");

    async function fetchBreeds(species) {
      try {
        if (cache.breeds[species]) return cache.breeds[species];
        const res = await fetch(`${API_ENDPOINT}/values/breeds?species=${encodeURIComponent(species)}`, { headers: { Accept: "application/json" } });
        if (!res.ok) return [];
        const data = await res.json();
        const arr = Array.isArray(data) ? data : [];
        const dedup = Array.from(new Set(arr)).sort((a, b) => formatBreedLabel(a).localeCompare(formatBreedLabel(b)));
        let list = prioritizeMixedBreeds(dedup);
        if (species.toLowerCase() === 'cat') list = prioritizeDomesticCatBreeds(list);
        cache.breeds[species] = list;
        return list;
      } catch (e) { return []; }
    }

    function filterBreeds(query, breeds) {
      const q = (query || "").trim().toLowerCase();
      if (!q) return breeds.slice(0, 150);
      return breeds.map((full) => {
          const label = formatBreedLabel(full).toLowerCase();
          const starts = label.startsWith(q);
          const includes = !starts && label.includes(q);
          return { full, label, score: starts ? 0 : includes ? 1 : 2 };
        })
        .filter((x) => x.score < 2)
        .sort((a, b) => (a.score - b.score) || a.label.localeCompare(b.label))
        .slice(0, 150)
        .map((x) => x.full);
    }

    function htmlEscape(s) {
      return String(s).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    }

    function syncHiddenBreed() {
      const sp = speciesSelect.value || "dog";
      const items = cache.breeds[sp] || [];
      const canonical = findCanonicalFromLabel(breedInput.value, items);
      breedHidden.value = canonical || "";
      if (canonical) clearError(breedInput);
    }

    const refreshBreeds = debounce(async () => {
      const sp = speciesSelect.value || "dog";
      await fetchBreeds(sp);
      syncHiddenBreed();
    }, 150);

    speciesSelect.addEventListener("change", async () => {
      breedInput.value = "";
      breedHidden.value = "";
      clearError(breedInput);
      await refreshBreeds();
    });

    const breedDropdown = document.createElement("ul");
    breedDropdown.id = "sp-promo-breed-dropdown";
    breedDropdown.className = "sp-dropdown hidden";
    breedDropdown.setAttribute("role", "listbox");
    document.body.appendChild(breedDropdown);

    function positionBreedDropdown() {
      const rect = breedInput.getBoundingClientRect();
      breedDropdown.style.left = (rect.left + window.scrollX) + "px";
      breedDropdown.style.top = rect.bottom + window.scrollY + "px";
      breedDropdown.style.width = rect.width + "px";
    }

    ["scroll","resize"].forEach(evt => window.addEventListener(evt, () => {
      if (breedDropdown.classList.contains("open")) positionBreedDropdown();
    }, { passive: true }));

    function showBreedDropdown(items) {
      if (!Array.isArray(items) || !items.length) return hideBreedDropdown();
      breedDropdown.innerHTML = items.map((full) => {
        return `<li role="option" data-full="${htmlEscape(full)}" tabindex="-1">${htmlEscape(formatBreedLabel(full))}</li>`;
      }).join("");
      positionBreedDropdown();
      breedDropdown.classList.remove("hidden");
      breedDropdown.classList.add("open");
      breedInput.setAttribute("aria-expanded", "true");
    }

    function hideBreedDropdown() {
      breedDropdown.classList.add("hidden");
      breedDropdown.classList.remove("open");
      breedInput.setAttribute("aria-expanded", "false");
    }

    breedInput.addEventListener("input", debounce(async () => {
      const sp = speciesSelect.value || "dog";
      const all = await fetchBreeds(sp);
      const matches = filterBreeds(breedInput.value, all);
      syncHiddenBreed();
      if (document.activeElement === breedInput) showBreedDropdown(matches);
    }, 150));

    breedInput.addEventListener("focus", async () => {
      const sp = speciesSelect.value || "dog";
      const all = await fetchBreeds(sp);
      showBreedDropdown(filterBreeds(breedInput.value, all));
    });

    breedInput.addEventListener("blur", () => {
      setTimeout(() => { if (!breedDropdown.contains(document.activeElement)) hideBreedDropdown(); }, 150);
    });

    breedDropdown.addEventListener("mousedown", (e) => e.preventDefault());
    breedDropdown.addEventListener("click", (e) => {
      const li = e.target.closest("li[data-full]");
      if (!li) return;
      const full = li.getAttribute("data-full");
      breedInput.value = formatBreedLabel(full);
      breedHidden.value = full;
      clearError(breedInput);
      hideBreedDropdown();
    });

    // --- Submission Logic ---
    function setSubmitting(isSubmitting) {
      submitBtn.disabled = isSubmitting;
      backBtn.disabled = isSubmitting;
      form.setAttribute("aria-busy", isSubmitting ? "true" : "false");
      submitBtn.textContent = isSubmitting ? "Processing..." : "Subscribe";
    }

    function renderPromoSuccess(plans, lead) {
      const petName = (lead && lead.pet_name) || "your pet";
      const hasPlans = plans && plans.length > 0;
      
      let softQuoteHtml = "";
      if (hasPlans) {
        let bestPlan = plans[0];
        if (plans.length > 1 && Number(plans[1].monthly) < Number(plans[0].monthly)) bestPlan = plans[1];
        const monthly = bestPlan.monthly != null ? `$${Number(bestPlan.monthly).toFixed(2)}` : "";
        const href = bestPlan.apply_url || "https://app.prudentpet.com/?promoCode=hiccup";
        
        softQuoteHtml = `
          <div style="margin-top: 1.5rem; padding: 1.25rem; border: 1px solid #e2e8f0; border-radius: 12px; background: #ffffff; text-align: left;">
            <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 0.75rem;">
                <img src="https://cdn.shopify.com/s/files/1/0339/3110/0219/files/Hiccup-Pet-Insurance_Main-Logo.png?v=1761852118" style="height: 22px; width: auto;" alt="Hiccup Pet Insurance" />
                <span style="font-size: 0.8rem; font-weight: 700; color: #9C3B8C; background: #f5d7e7; padding: 3px 10px; border-radius: 99px;">Partner Perk</span>
            </div>
            <p style="font-size: 0.95rem; color: #475569; margin-bottom: 1rem; line-height: 1.4; text-align:center;">
              We also found a customized health plan for <strong>${petName}</strong> starting at just <strong>${monthly}/mo</strong>.
            </p>
            <a href="${href}" target="_blank" rel="noopener" style="display: block; text-align: center; width: 100%; padding: 0.8rem; border: 2px solid #9C3B8C; color: #9C3B8C; border-radius: 8px; font-weight: 700; text-decoration: none; font-size: 1rem; transition: all 0.2s ease;">
              View ${petName}'s Quote
            </a>
          </div>
        `;
      }

      // 1. Keep the progress bar container, bump to 100%, color it green
      const progressHTML = `
        <div class="sp-progress-container" style="margin-bottom: 1rem;">
          <div class="sp-progress-bar" style="width: 100%; background: rgba(var(--color-green-500), 1) !important;"></div>
        </div>
      `;

      // 2. The Alpine native coupon snippet (Aligned & Re-formatted)
      const couponHtml = `
        <div class="block-sections--18768581591099__popup_promotion_fg8gaG text-[rgb(var(--colors-text))] p-break-words rte mt-3 lg:mt-5 leading-tight rte">
          
          <p style="margin-bottom: 0.75rem; font-size: 1.05rem; color: #475569;">Use the code below for 10% off your order:</p>
          
          <div :title="copySuccess?'Copied':'Copy code'" x-data="xCouponCode" x-on:click="copyCode()" data-message="Copy failed" class="cursor-pointer border rounded-full border-dashed items-center w-fit inline-flex justify-center" style="border-color: rgba(var(--color-blue-900), 1) !important; color: rgba(var(--color-blue-900), 1) !important; margin-bottom: 1rem; padding: 0.6rem 1.5rem; background: #f8fafc; transition: all 0.2s ease;">
            
            <span class="coupon-code font-bold" x-ref="code_value" style="font-size: 1.5rem; line-height: 1; padding-top: 3px;">SNUGGLEUP10</span>
            
            <div class="flex items-center justify-center" style="margin-left: 0.75rem; width: 1.5rem; height: 1.5rem; position: relative;">
              <span x-show="!copySuccess" x-transition:enter="transition-all absolute ease-in-out duration-300" x-transition:enter-start="opacity-0 absolute transform translate-y-full" x-transition:enter-end="opacity-100 absolute transform translate-y-0" x-transition:leave="transition-all absolute ease-in-out duration-300" x-transition:leave-end="opacity-0 transform absolute -translate-y-full" style="display: flex; width: 100%; height: 100%; align-items: center;">
                <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill="none"><path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M16.615 2H3.538A1.538 1.538 0 0 0 2 3.538v13.077a1.538 1.538 0 0 0 1.538 1.538h13.077a1.538 1.538 0 0 0 1.538-1.538V3.538A1.538 1.538 0 0 0 16.615 2 M22 6.615v13.846A1.538 1.538 0 0 1 20.462 22H6.615"></path></svg>
              </span>
              <span x-show="copySuccess" x-transition:enter="transition-all ease-in-out duration-300" x-transition:enter-start="opacity-0 transform translate-y-full" x-transition:enter-end="opacity-100 transform translate-y-0" x-transition:leave="transition ease-in-out duration-300" x-transition:leave-end="opacity-0 transform -translate-y-full" style="display: none; width: 100%; height: 100%; align-items: center;">
                <svg width="100%" height="100%" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg"><path d="M20.3232 6.71851L9.32324 17.7185L4.32324 12.7185" fill="none" stroke="currentColor" stroke-width="5" stroke-linecap="square" stroke-linejoin="round"></path></svg>
              </span>
            </div>

          </div>
          
          <p style="margin-top: 0.25rem; font-size: 1rem; color: #475569; padding: 0 1rem; line-height: 1.4;">We’ve sent it to your inbox so you have it when you’re ready.</p>

        </div>
      `;

      root.innerHTML = `
        ${progressHTML}
        <div class="sp-success" style="animation: fadeIn 0.5s ease-in-out; text-align: center; padding: 0.5rem 0;">
          <h2 class="heading--primary" style="margin-bottom: 0.5rem; font-size: 1.75rem;">Welcome to the Pack!</h2>
          ${couponHtml}
          ${softQuoteHtml}
        </div>
      `;
    }

    async function submitPromoForm() {
      track("promo_form_submit_attempt", { included_pet: petIntent });
      results.innerHTML = "";
      clearAllErrors(form);

      const hp = root.querySelector("#sp-promo-company");
      if (hp && hp.value) return; 

      setSubmitting(true);

      try {
        const formData = new FormData(form);
        const lead = Object.fromEntries(formData.entries());
        
        // Force implied consent for API
        lead.consent = true; 
        
        // Strip pet data if they bypassed the pet fields
        if (petIntent === false) {
          delete lead.species;
          delete lead.gender;
          delete lead.pet_name;
          delete lead.dob;
          delete lead.breed;
          delete lead.breed_code;
        } else {
          lead.breed = lead.breed_code || lead.breed;
          if (lead.gender) {
            const g = String(lead.gender).toUpperCase();
            lead.gender = g.startsWith("F") ? "F" : g.startsWith("M") ? "M" : "";
          }
        }

        if (lead.zip) lead.zip = String(lead.zip).replace(/\D/g, "").slice(0, 5);
        lead.formType = "promo_popup";

        const payload = {
          lead,
          qr: Object.fromEntries(qs.entries()),
          listId: LIST_ID,
          siteId: SITE_ID
        };

        const res = await fetch(API_ENDPOINT, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });

        if (!res.ok) {
          let details = await res.text();
          track("promo_form_submit_error", { status: res.status });
          results.innerHTML = `<div class="message message--background"><p>Sorry, something went wrong. Please try again.</p></div>`;
          return;
        }

        const data = await res.json();
        renderPromoSuccess((data && data.plans) || [], lead);

      } catch (err) {
        results.innerHTML = `<div class="message message--background"><p>Sorry, something went wrong. Please try again.</p></div>`;
      } finally {
        setSubmitting(false);
      }
    }

    // ========================================================
    // MOBILE OVERLAY, SCROLL LOCK, & TEASER LOGIC
    // ========================================================
    const popupContainer = root.closest('[x-show]'); // The element Alpine toggles
    const eurusPopupWrapper = document.getElementById('eurus-popup');

    if (popupContainer && eurusPopupWrapper) {
      // 1. Inject the overlay into the DOM dynamically
      const overlay = document.createElement('div');
      overlay.style.cssText = "position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; background: black; z-index: 50; transition: opacity 0.3s ease; opacity: 0; pointer-events: none;";
      
      eurusPopupWrapper.insertBefore(overlay, eurusPopupWrapper.firstChild);

      // 2. Allow clicking the dark overlay to close the popup
      overlay.addEventListener('click', () => {
        const closeBtn = popupContainer.querySelector('.group-close-btn');
        if (closeBtn) closeBtn.click();
      });

      // 3. Watch for Alpine.js opening/closing the popup
      const observer = new MutationObserver(() => {
        const isHidden = popupContainer.style.display === 'none';
        const isMobile = window.matchMedia('(max-width: 767px)').matches;
        
        if (!isHidden && isMobile) {
          // Popup is OPEN and on mobile: Lock scroll and fade in overlay
          document.body.style.overflow = 'hidden'; 
          overlay.style.opacity = '0.6';
          overlay.style.pointerEvents = 'auto';
        } else {
          // Popup is CLOSED or on Desktop: Unlock scroll and hide overlay
          document.body.style.overflow = ''; 
          overlay.style.opacity = '0';
          overlay.style.pointerEvents = 'none';
        }
      });

      observer.observe(popupContainer, { attributes: true, attributeFilter: ['style'] });

      // 4. Safely clear the lock if the user rotates their phone/resizes the window
      window.addEventListener('resize', () => {
        const isHidden = popupContainer.style.display === 'none';
        const isMobile = window.matchMedia('(max-width: 767px)').matches;
        
        if (!isMobile) {
          document.body.style.overflow = ''; 
          overlay.style.opacity = '0';
          overlay.style.pointerEvents = 'none';
        } else if (!isHidden) {
          document.body.style.overflow = 'hidden'; 
          overlay.style.opacity = '0.6';
          overlay.style.pointerEvents = 'auto';
        }
      });
    }

    // 5. Stop the teaser's bounce animation on first interaction
    let hasInteractedWithMinimal = false;
    document.addEventListener('click', (e) => {
      if (!hasInteractedWithMinimal && e.target.closest('[id^="popup-minimal-"]')) {
        hasInteractedWithMinimal = true;
        // Adds a class to shut off the CSS keyframe animation forever
        document.querySelectorAll('[id^="popup-minimal-"]').forEach(el => el.classList.add('sp-interacted'));
      }
    });

    refreshBreeds();

  } catch (err) {
    console.error("[sp-promo] Fatal init error:", err);
  }
})();